import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)
const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        userInfo: {
            yhid: JSON.parse(sessionStorage.getItem('userInfo')) ? JSON.parse(sessionStorage.getItem('userInfo')).yhid : '',
            realname: JSON.parse(sessionStorage.getItem('userInfo')) ? JSON.parse(sessionStorage.getItem('userInfo')).realname : '',
            zhid: JSON.parse(sessionStorage.getItem('userInfo')) ? JSON.parse(sessionStorage.getItem('userInfo')).zhid : '',
            zhmc: JSON.parse(sessionStorage.getItem('userInfo')) ? JSON.parse(sessionStorage.getItem('userInfo')).zhmc : '',
            bjid: localStorage.getItem('bjid') || '',
            jxid: localStorage.getItem('jxid') || '',
            xzid: localStorage.getItem('xzid') || '',
        },
        token: sessionStorage.getItem('token') || '',
        yycdid: Number(sessionStorage.getItem('yycdid')) || '',
        is_socket: 0,
        socket: null,
        fellow: '',
        term: '',
    }, mutations: {
        setSock(state, socket) {
            state.socket = socket
        },
        // 存储token
        setToken(state, token) {
            state.token = token
        }, // 存储用户信息
        setInfo(state, userInfo) {
            state.userInfo = userInfo
        }, // 存储应用信息
        setYycdid(state, yycdid) {
            state.yycdid = yycdid
        }, setSocket(state, status) {
            state.is_socket = status;
            console.log(state.is_socket)
        }, // 存储result对象
        setResult(state, result) {
            state.userInfo.bjid = result.bjid;
            state.userInfo.jxid = result.jxid;
            state.userInfo.xzid = result.xzid;

            // 将结果存储在本地存储中
            localStorage.setItem('bjid', result.bjid);
            localStorage.setItem('jxid', result.jxid);
            localStorage.setItem('xzid', result.xzid);
        },
        setVip(state, fellow) {
            state.fellow = fellow
        },
        setVipTime(state, term) {
            state.term = term
        },
    }, actions: {}, getters: {}
})

export default store
